import React from 'react';
import { Box } from '@atlaskit/primitives';
import { AITopicsByPerson } from '../ai-topics';
export var KnowledgeCardsTopics = function KnowledgeCardsTopics(props) {
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(AITopicsByPerson, props));
};